// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sMfC","fullView":"styles_fullView__3oS1e"};